export enum menuTypes {
    SET_MENU_OPEN = 'SET_MENU_OPEN',
    SET_HEADER_MENU_OPEN = 'SET_HEADER_MENU_OPEN',
    SET_AI_POPUP_OPEN = 'SET_AI_POPUP_OPEN',
    SET_SHOW_AD = 'SET_SHOW_AD',
}
